import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'react-router-dom/Link'
import { Helmet } from 'react-helmet';

import {observer} from 'mobx-react'
import eventsStore from '../../modules/Events/Store'

import Logo from '../../elements/brand/Logo';
import EventJumbo from '../../modules/Events/elements/EventJumbo';
import EventList from '../../modules/Events/elements/EventList';


import OrganizationsLogoList from '../../modules/Partners/elements/OrganizationsLogoList';

import Projects from './elements/Projects'
import SomeTerriblyUglyPerson from './about-photo.png'

import styles from './index.sass';


const EVENTS_LIST_LIMIT = 5;

//
const dummyEvent = {
    title: 'Loading...',
    timeframe: {
        start: '2020-12-30T18:30:00+02:00'
    },
    venue: {
        location: {
            city: {
                name: 'Loading...',
            }
        }
    }
};

const dummyEvents = [];

const getOrganizationLogoObjects = (paths) => {
    const result = [];
    for (let i = 0; i < paths.length; i++) {
        result.push({
            logo: {
                normal: '/img/organizations/' + paths[i]
            }
        })
    }

    return result
};

// We push EVENTS_LIST_LIMIT + 1 events since the first one will be the one in the EventJumbo.
for (let i = 0; i < EVENTS_LIST_LIMIT + 1; i++) {
    dummyEvents.push(dummyEvent)
}

@observer
export default class HomePage extends Component {

    static contextTypes = {
        layoutSetHasInvertedTop: PropTypes.func
    };

    async componentWillMount() {
        if (eventsStore.isPopulated) {
            return
        }

        eventsStore.populate();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.context.layoutSetHasInvertedTop(250);
    }

    componentWillUnmount() {
        this.context.layoutSetHasInvertedTop(false);
    }

    render() {
        const events = eventsStore.events.length > 0 ? eventsStore.events : dummyEvents;

        return (
            <main className={styles.root}>

                <Helmet>
                    <title>Gamedev.js - Spotkania z tworzeniem gier w HTML5 i JavaScript</title>
                    <meta name="description" content="Gamedev.js to społeczność organizująca spotkania związane z tworzeniem gier w technologii HTML5 i języku JavaScript, także na urządzenia mobilne" />
                    <meta name="keywords" content="gamedev, html5, javascript, tworzenie gier, społeczność, spotkania, meetup, warszawa, kraków, poznań, gamejam, hackaton" />
                </Helmet>

                <EventJumbo summary event={events[0]} className="skewed" />

                <section className={classNames(styles.events, 'skewed grid exposed-soft border-bottom border-simpler')}>
                    <h3 className="g-type-title-section g-type-title-left">
                        <Link to="/wydarzenia">Wydarzenia</Link>
                        <a href="https://api.gamedevjs.pl/events.rss"><i className="rss icon" /></a>
                    </h3>
                    <p>
                        <b>Spotkania z tworzeniem gier w HTML5 i JavaScript</b><br />
                        Zasubskrybuj nasze wydarzenia i bądź na bieżąco!
                    </p>
                    <EventList events={events.slice(1, EVENTS_LIST_LIMIT + 1)}/>
                    <Link className="primary button" to="/wydarzenia">Więcej wydarzeń...</Link>
                </section>

                <section className={classNames(styles.pitch, 'grid')}>
                    <h3 className="g-type-title-section line-flat">
                        <Link to="/kontakt">Chcesz się pokazać?</Link>
                    </h3>
                    <p>
                        Chcesz <strong>opowiedzieć</strong> o praktycznych zastosowaniach mechaniki kwantowej w tworzeniu gier?
                        A może chcesz <strong>zorganizować</strong> jakiś event całkowicie po swojemu?
                        Reprezentujesz firmę i chcesz <strong>dotrzeć do doświadczonych developerów</strong>?
                    </p>
                    <p>
                        Jesteśmy otwarci na wszystko i mamy proste, równie <Link to="/kontakt">otwarte procedury</Link>.<br />
                        Przy organizacji naszych wydarzeń współpracowaliśmy już z takimi organizacjami, jak:
                    </p>

                    <OrganizationsLogoList organizations={getOrganizationLogoObjects([
                        'mozilla.png',
                        'github.png',
                        'itmagination.png'
                    ])} />

                    <p>
                        Będziesz więc w doborowym towarzystwie. Nie zwlekaj, po prostu <Link to="/kontakt">skontaktuj się z nami</Link>.
                    </p>
                </section>

                <div className={classNames(styles.about, 'skewed')}>
                    <section className="grid">
                        <article className="g-type-major markdown exposed-soft border-top border-simpler">
                            <h3 className="g-type-title-section g-type-title-left">
                                <Link to="/o-nas">O nas</Link>
                            </h3>
                            <img src={SomeTerriblyUglyPerson} />
                            <p>
                                Gamedev.js to <strong>społeczność</strong> organizująca <strong>spotkania</strong> związane
                                z <strong>tworzeniem gier w technologii HTML5 i języku JavaScript</strong>,
                                także na urządzenia mobilne.
                                Darmowy wstęp, piwo, pizza i dobra zabawa to nasze minimum. Poznaj technologię przyszłości
                                i twórz gry, które podbiją rynek, a Ciebie zrobią milionerem.
                            </p>

                            <p>
                                Inicjatywa Gamedev.js to nie tylko spotkania czy hakatony, ale także <strong>profesjonalne szkolenia</strong> z szeroko
                                pojętego tworzenia gier HTML5 i JavaScript. Skorzystaj z naszej wiedzy i wieloletniego doświadczenia w branży,
                                by rozwijać własne umiejętności i podnosić kwalifikacje swoich pracowników.
                            </p>
                            <Logo Element={Link} to="/o-nas" active before={<div>Więcej o inicjatywie</div>} className={styles.link} />
                        </article>
                    </section>
                </div>
                <Projects />
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js